import React, { useContext } from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SearchBarContext, SubmitOnEnterOverSelectCallback } from '../../../../../components/SearchBar';
import SearchBarRow from '../../../../../components/SearchBar/SearchBarRow';
import moment from "moment/moment";

import DatePicker from 'react-datepicker';

const PrimarySearchItems = () => {
  const intl = useIntl();
  const { register } = useContext(SearchBarContext);

  return (
    <SearchBarRow>
      <div className="form-group">
        <label>{intl.formatMessage({ id: 'admin-area.payloads.status-field' })}</label>
        <select className="form-control" {...register('status')} onKeyUp={SubmitOnEnterOverSelectCallback}>
          <option value="">{intl.formatMessage({ id: 'shared.dropdown.please-select' })}</option>
          <option value="pending">{intl.formatMessage({ id: 'admin-area.payloads.status.pending' })}</option>
          <option value="complete">{intl.formatMessage({ id: 'admin-area.payloads.status.complete' })}</option>
          <option value="error">{intl.formatMessage({ id: 'admin-area.payloads.status.error' })}</option>
        </select>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'admin-area.payloads.search.has-errors' })}</label>
        <select className="form-control" {...register('hasErrors')} onKeyUp={SubmitOnEnterOverSelectCallback}>
          <option value="">{intl.formatMessage({ id: 'shared.dropdown.please-select' })}</option>
          <option value="true">{intl.formatMessage({ id: 'shared.yes' })}</option>
          <option value="false">{intl.formatMessage({ id: 'shared.no' })}</option>
        </select>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'admin-area.payloads.search.unit' })}</label>
        <input className="form-control" {...register('unit')}></input>
      </div>

      <div className="form-group">
        <label>{intl.formatMessage({ id: 'admin-area.payloads.simulation-name-field' })}</label>
        <input className="form-control" {...register('simulationName')}></input>
      </div>
    </SearchBarRow>
  );
};

const SecondarySearchItems = (props) => {
  const intl = useIntl();
  const { register, control } = useContext(SearchBarContext);

  return props.organisations && (
    <div className="searchbar-secondary-items extended">
      <SearchBarRow>
        <div className="form-group">
          <label>{intl.formatMessage({ id: 'admin-area.payloads.created-time-field' })}</label>
          <div className="date-range">
            <Controller
              control={control}
              name="dateCreatedStart"
              render={({ field }) => (
                <DatePicker
                  name="dateCreatedStart"
                  className="form-control"
                  placeholderText={intl.formatMessage({ id: 'shared.forms.start_date' })}
                  selected={field.value ? moment(field.value).toDate() : undefined}
                  onChange={(date) => field.onChange(date)}
                  dateFormat={window._FLAIM_DATE_FORMAT}
                  locale={window._FLAIM_LOCALE}
                />
              )}
            />

            <Controller
              control={control}
              name="dateCreatedEnd"
              render={({ field }) => (
                <DatePicker
                  name="dateCreatedEnd"
                  className="form-control"
                  placeholderText={intl.formatMessage({ id: 'shared.forms.end_date' })}
                  selected={field.value ? moment(field.value).toDate() : undefined}
                  onChange={(date) => field.onChange(date)}
                  dateFormat={window._FLAIM_DATE_FORMAT}
                />
              )}
            />
          </div>
        </div>

        <div className="form-group">
          <label>{intl.formatMessage({ id: 'admin-area.payloads.organisation-field' })}</label>
          <select className="form-control" {...register('organisation_id')} onKeyUp={SubmitOnEnterOverSelectCallback}>
            <option key="0" value="">
              {intl.formatMessage({ id: 'shared.dropdown.please-select' })}
            </option>
            {props.organisations.map((org) => {
              return (
                <option key={org.id} value={org.id}>
                  {org.name}
                </option>
              );
            })}
          </select>
        </div>
      </SearchBarRow>
    </div>
  );
};

SecondarySearchItems.propTypes = {
  organisations: PropTypes.array.isRequired,
};

export { PrimarySearchItems, SecondarySearchItems };
